import { ENDPOINT, endpointWrapper } from './meta.api';

interface UpsertConversationResponse {
    id?: string;
    label?: string;
    messages?: unknown[];
    updatedAt?: string | null;
    error?: string;
}

export const fetchConversations = () =>
    endpointWrapper({ domain: 'chat/conversations', method: 'GET' });

export const fetchConversation = (id: string) =>
    endpointWrapper({ domain: `chat/conversations/${id}`, method: 'GET' });

/**
 * Upsert a conversation. Returns the parsed JSON body on both 200 and 409.
 * On 409 (stale write), the response includes the server's current state
 * with an `error` field — the caller should check for `res.error` to detect conflicts.
 */
export const upsertConversation = async (data: {
    id: string;
    label?: string;
    messages?: unknown[];
    updatedAt?: string;
}): Promise<UpsertConversationResponse> => {
    const response = await fetch(`${ENDPOINT}/chat/conversations/`, {
        method: 'POST',
        body: JSON.stringify(data),
    });

    if (response.ok || response.status === 409) {
        const text = await response.text();
        return text ? JSON.parse(text) : {};
    }

    const err = new Error('Response not okay!');
    (err as Error & { status?: number }).status = response.status;
    throw err;
};

export const deleteConversation = (id: string) =>
    endpointWrapper({ domain: `chat/conversations/${id}`, method: 'DELETE' });
